import {
  RuntimeHooksContext,
  useRuntimeContext,
} from "../../shared/runtime-context";
import { getDynamicDataCustomPropertyName } from "../../shared/utils/css";

export const useGetCssVariablesForDesignLibrary = () => {
  const designLibrary =
    useRuntimeContext(RuntimeHooksContext).useDesignLibrary();

  if (!designLibrary) {
    return {};
  }

  const styleProperties: Record<string, string> = {};
  const baseDynamicDataKey = `library.${designLibrary.id}.styles`;

  const savedStyles = designLibrary?.savedStyles;
  if (Object.keys(savedStyles).length === 0) {
    return {};
  }

  // TODO (Fran 2024-10-28 REPL-14578): We may want to improve this to avoid creating variables for attributes
  // that are not used in any component.
  for (const [savedStyleId, { attributes }] of Object.entries(savedStyles)) {
    for (const attributeKey in attributes) {
      // NOTE (Fran 2024-11-15): We don't want to create dynamic data variables for
      // the type, colorType, and htmlTag attributes because they are used for internal
      // purposes and not for styling components.
      if (["type", "colorType", "htmlTag"].includes(attributeKey)) {
        continue;
      }

      const dynamicDataKey = getDynamicDataCustomPropertyName(
        `${baseDynamicDataKey}.${savedStyleId}.attributes.${attributeKey}`,
      );
      styleProperties[dynamicDataKey] =
        attributes[attributeKey as keyof typeof attributes]!;
    }
  }

  return styleProperties;
};
